export default __webpack_public_path__ + "static/wallpaper-2c7d8d557bffabd7412552f10b0aaddc.jpg";